'use client';

import CWButton from '@/context/global/components/g00/g00-d00-g006-cw-button';
import IconEmptyQueue from '@/context/global/components/Icon/IconEmptyQueue';
import { cn } from '@/context/global/utils/cn';
import { useTranslations } from 'next-intl';

type EmptyQueueProps = {
  onAddSong?: () => void;
  className?: string;
};

const EmptyQueue = ({ onAddSong, className }: EmptyQueueProps) => {
  const t = useTranslations('Karaoke.EmptyQueue');

  return (
    <div
      className={cn(
        'flex h-full w-full flex-col items-center justify-center gap-12 bg-black px-4 landscape:gap-3',
        className,
      )}
    >
      {/* Illustration */}
      <div className="h-[300px] w-[236px] md:h-[360px] md:w-[283px] lg:h-[450px] lg:w-[354px] landscape:max-md:h-[180px] landscape:max-md:w-[150px]">
        <IconEmptyQueue className="h-full w-full" />
      </div>

      {/* Text and Button Section */}
      <div className="flex w-full flex-col items-center gap-6 landscape:gap-1">
        {/* Text */}
        <div className="flex flex-col items-center text-center">
          <p className="text-[28px] font-bold leading-[44px] text-white md:text-[48px] md:leading-[56px] lg:text-[56px] lg:leading-[64px] landscape:max-md:text-base landscape:max-md:leading-normal">
            {t('title')}
          </p>
          <p className="text-[20px] leading-[38px] text-[#B5B5B5] md:text-[36px] md:leading-[44px] lg:text-[42px] lg:leading-[52px] landscape:max-md:text-sm landscape:max-md:leading-normal">
            {t('description')}
          </p>
        </div>

        {/* Button */}
        <CWButton
          title={t('addSongNow')}
          onClick={onAddSong}
          variant="gray"
          outline
          className="w-[200px] px-12 py-3 hover:border-white hover:bg-transparent hover:text-white focus:bg-ais-green"
        />
      </div>
    </div>
  );
};

export default EmptyQueue;
